import { axiosRequest } from './request'
import requestApi from '@kuailu/api-request-saas'
import SSOClient from '@kuailu/sso'

function getToken() {
  return SSOClient.accessToken ?? ''
}

export default requestApi(axiosRequest, getToken)
